import { ORIGINAL_COORDS } from '../constants/dronePath';

/**
 * Interpolates points between two coordinates
 * @param a - Start coordinate [longitude, latitude]
 * @param b - End coordinate [longitude, latitude]
 * @param n - Number of interpolation points
 * @returns Array of interpolated coordinates
 */
export const interpolate = (a: [number, number], b: [number, number], n: number): [number, number][] => {
  const points: [number, number][] = [];
  for (let i = 1; i < n; i++) {
    const t = i / n;
    points.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]);
  }
  return points;
};

/**
 * Generates smooth coordinates by interpolating between original coordinates
 * @returns Array of smoothed coordinates
 */
export const getSmoothCoords = (): [number, number][] => {
  const smoothCoords: [number, number][] = [];
  for (let i = 0; i < ORIGINAL_COORDS.length - 1; i++) {
    smoothCoords.push(ORIGINAL_COORDS[i]);
    smoothCoords.push(...interpolate(ORIGINAL_COORDS[i], ORIGINAL_COORDS[i + 1], 5));
  }
  smoothCoords.push(ORIGINAL_COORDS[ORIGINAL_COORDS.length - 1]);
  return smoothCoords;
};
